(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-featured-press';
  var sectionState = new Map();

  var SET_CLASS = 'oddit-section-featured-press__set';
  var CLONE_CLASS = 'oddit-section-featured-press__set--clone';
  var MAX_SETS = 12;

  function stripReveal(root) {
    var els = root.querySelectorAll('[class*="oddit-reveal"]');
    for (var i = 0; i < els.length; i++) {
      var kept = [];
      var classes = els[i].className.split(/\s+/);
      for (var j = 0; j < classes.length; j++) {
        if (classes[j] && classes[j].indexOf('oddit-reveal') !== 0 && classes[j] !== 'is-visible') {
          kept.push(classes[j]);
        }
      }
      els[i].className = kept.join(' ');
    }
  }

  function initMarquee(section) {
    var marquee = section.querySelector('[data-marquee]');
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!marquee || !track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // A two-copy marquee only loops seamlessly when one set is at least as wide
    // as the viewport. When the logo strip is narrower (common on tablets), the
    // single set leaves a bare strip on the right edge before the loop repeats.
    // Clone the set until the track overfills the viewport so content is always
    // present across the full width, then translate by exactly one set-width.
    function ensureFill() {
      var setWidth = firstSet.scrollWidth;
      var viewport = marquee.clientWidth;
      // Desktop: the set is `display: contents` (no box) → scrollWidth 0; the
      // animation is disabled in CSS, so no clones are needed.
      if (!setWidth || !viewport) return;
      var needed = Math.min(Math.ceil(viewport / setWidth) + 1, MAX_SETS);
      var current = track.querySelectorAll('.' + SET_CLASS).length;
      for (var i = current; i < needed; i++) {
        var clone = firstSet.cloneNode(true);
        clone.removeAttribute('data-marquee-set');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add(CLONE_CLASS);
        // The source set carries `oddit-reveal` (opacity:0 until the global
        // IntersectionObserver flags it). That observer never sees these
        // late-added clones, so strip the reveal classes or the clones stay
        // invisible — leaving a wide gap in the loop.
        stripReveal(clone);
        track.appendChild(clone);
      }
    }

    function measure() {
      ensureFill();
      var setWidth = firstSet.scrollWidth;
      if (!setWidth) return;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    var onMotionChange = function (e) {
      e.matches ? disable() : enable();
    };
    reducedMotion.addEventListener('change', onMotionChange);

    var onVisibility = function () {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    };
    document.addEventListener('visibilitychange', onVisibility);

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      onMotionChange: onMotionChange,
      onVisibility: onVisibility,
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion && state.onMotionChange) {
      state.reducedMotion.removeEventListener('change', state.onMotionChange);
    }
    if (state.onVisibility) {
      document.removeEventListener('visibilitychange', state.onVisibility);
    }
  }

  function initSection(section) {
    if (sectionState.has(section)) return;
    sectionState.set(section, initMarquee(section));
  }

  function destroySection(section) {
    if (!sectionState.has(section)) return;
    destroyMarquee(sectionState.get(section));
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
